import React from 'react'
import styles from './EdofSection3.module.css'
const EdofSection3 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <div className={styles.VisionContain}>
                        <h1> Vision <br />
                            Dissatisfaction</h1>
                        <h3>The leading cause of
                            dropout in presbyopic
                            contact lens wearers.</h3>
                        <p>
                            Approximately
                            <span> 50% of contact
                                lens wearers discontinue use by
                                age 50,</span> coinciding with the
                            onset of presbyopia. Competing
                            focal zones can increase visual
                            artifacts and adaptation
                            demands for some patients.</p>
                    </div>
                </div>
                <div className={styles.RightSection}>
                    <img src='/Images/vision_img.webp' alt='/Images/vision_img' loading="lazy" decoding="async" />
                </div>
            </div>
            <div className={styles.lensDesignWrapper}>
                <div className={styles.lensTypes}>
                    {/* Progressive */}
                    <div className={styles.lensItem}>
                        <p className={styles.lensLabel}>Progressive</p>
                        <div className={styles.circleContainer}>
                            <img src='/Images/001.png' alt='Progressive lens design' loading="lazy" decoding="async" />
                        </div>
                    </div>

                    {/* Concentric */}
                    <div className={styles.lensItem}>
                        <p className={styles.lensLabel}>Concentric</p>
                        <div className={styles.circleContainer}>
                            <img src='/Images/002.png' alt='Concentric lens design' loading="lazy" decoding="async" />
                        </div>
                    </div>

                    {/* Segmented */}
                    <div className={styles.lensItem}>
                        <p className={styles.lensLabel}>Segmented</p>
                        <div className={styles.circleContainer}>
                            <img src='/Images/003.png' alt='Segmented lens design' loading="lazy" decoding="async" />
                        </div>
                    </div>
                </div>

                {/* Legend */}
                <div className={styles.lensLegend}>
                    <div className={`${styles.legendItem} ${styles.legendNear}`}>
                        <span>Near</span>
                    </div>
                    <div className={`${styles.legendItem} ${styles.legendIntermediate}`}>
                        <span>Intermediate</span>
                    </div>
                    <div className={`${styles.legendItem} ${styles.legendDistance}`}>
                        <span>Distance</span>
                    </div>
                </div>
            </div>
            <div className={styles.MobileImg}>
                <img src='/Images/vision_img.webp' alt='/Images/vision_img' loading="lazy" decoding="async" />
            </div>

        </div>
    )
}

export default EdofSection3
